import { IconVariants } from '../components/foundations/Icon';
import { trackMixpanelEvent } from '../utils/general';

export const INTERACTIVE_SERVICE_BASE_URL = 'interactive-service';

export const MESSAGE_ROLES = {
    USER: 'user',
    ASSISTANT: 'assistant',
    SYSTEM: 'system',
};

export const STEP_STATUS = {
    PENDING: 'pending',
    RUNNING: 'running',
    COMPLETED: 'completed',
    FAILED: 'failed',
};

export const STEP_STATUS_ICON = {
    [STEP_STATUS.COMPLETED]: { name: 'check', variant: IconVariants.SUCCESS },
    [STEP_STATUS.FAILED]: { name: 'x', variant: IconVariants.ERROR },
    [STEP_STATUS.RUNNING]: { name: 'loader-2', variant: IconVariants.ACTIVE, isSpinning: true },
};

export const ERROR_TYPES = {
    ERROR: 'report_error',
    USER_ERROR: 'report_user_error',
};

export const EVENT_TYPES = {
    // Lifecycle events
    STARTED: 'report_generation_started',
    COMPLETED: 'report_generation_completed',
    CANCELLED: 'report_cancelled',
    ...ERROR_TYPES,
    // Content events
    TOKEN: 'token',
    TOKEN_BATCH: 'token_batch',
    STEP_UPDATE: 'step_update',
    ARTIFACT: 'data_artifact',

    RERUN_STARTED: 'report_rerun_started',

    RESPONSE_COMPLETE: 'response_complete',
    SESSION_TITLE_UPDATED: 'session_title_updated',

    // AI SDK stream event types
    START: 'start',
    FINISH: 'finish',
    TEXT_START: 'text-start',
    TEXT_DELTA: 'text-delta',
    TEXT_END: 'text-end',
    REASONING_START: 'reasoning-start',
    REASONING_DELTA: 'reasoning-delta',
    REASONING_END: 'reasoning-end',
    TOOL_INPUT_START: 'tool-input-start',
    TOOL_INPUT_AVAILABLE: 'tool-input-available',
    TOOL_OUTPUT_AVAILABLE: 'tool-output-available',
    EPHEMERAL_UPDATE_START: 'ephemeral-update-start',
    EPHEMERAL_UPDATE_DELTA: 'ephemeral-update-delta',
    EPHEMERAL_UPDATE_END: 'ephemeral-update-end',
    STEP_START: 'step-start',
    STEP_FINISH: 'step-finish',
    DATA_PREFIX: 'data-',
    STREAM_ERROR: 'error',
};

export const SESSION_TYPES = {
    CHAT: 'chat',
    DRILLDOWN: 'drilldown',
};

export const MAX_DISPLAY_ROWS = 200;
export const SESSION_TITLE_PLACEHOLDER_MAX_LENGTH = 50;

export const ARTIFACT_TYPES = {
    GRID: 'grid',
    TABLE: 'table',
    WIDGET: 'widget',
    MARKDOWN: 'markdown',
    CODE: 'code',
    ERROR: 'error',
};

export const CONTEXT_PROD_MODE = 'prod';
export const CONTEXT_PLAYGROUND_MODE = 'playground';

export const CONTEXT_ENV_TOGGLE_OPTIONS = [
    { option: CONTEXT_PROD_MODE, label: 'Prod Context' },
    { option: CONTEXT_PLAYGROUND_MODE, label: 'Playground Context' },
];

export const AGENT_STATE = {
    THINKING: 'thinking',
    RUNNING: 'running',
    DONE: 'done',
};

export const THINKING_FLICKER_DELAY_MS = 1000;

export const AGENT_CHAT_EVENT_PREFIX = 'Agent Chat';

export const CHAT_EVENTS = {
    NEW_CHAT: 'New Chat',
    OPEN_CHAT: 'Open Chat',
    DELETE_CHAT: 'Delete Chat',
    RENAME_CHAT: 'Rename Chat',
    SEND_MESSAGE: 'Send Message',
    STOP_GENERATION: 'Stop Generation',
    REGENERATE_RESPONSE: 'Regenerate Response',
    MICROPHONE_START: 'Microphone Start',
    MICROPHONE_STOP: 'Microphone Stop',
    COPY_MESSAGE: 'Copy Message',
    TOGGLE_SESSION_SIDEBAR: 'Toggle Session Sidebar',
    VIEW_DASHBOARD: 'View Dashboard',
    DOWNLOAD_CSV: 'Download CSV',
    COPY_CSV: 'Copy CSV',
    EXPORT_GOOGLE_SHEETS: 'Export to Google Sheets',
};

export const trackChatEvent = (eventName, params) => trackMixpanelEvent(AGENT_CHAT_EVENT_PREFIX, eventName, params);

export const FEEDBACK_EVENT_PREFIX = 'Agent Feedback';

export const FEEDBACK_RATING = {
    POSITIVE: 'positive',
    NEGATIVE: 'negative',
};

export const FEEDBACK_TOAST_VARIANT = {
    SUCCESS: 'success',
    FAILURE: 'failure',
};

export const FEEDBACK_COMMENT_MAX_LENGTH = 2000;

export const NEGATIVE_REASON_KEYS = [
    'WRONG_DATA',
    'MISUNDERSTOOD',
    'MISSING_INFO',
    'BAD_FORMATTING',
    'TOO_VERBOSE',
    'TOO_SLOW',
    'OTHER',
];

export const FEEDBACK_THUMBS = [
    {
        rating: FEEDBACK_RATING.POSITIVE,
        filledIcon: 'thumb-up-2-fill',
        outlinedIcon: 'thumb-up-2-line',
        selectedVariant: IconVariants.DARK,
    },
    {
        rating: FEEDBACK_RATING.NEGATIVE,
        filledIcon: 'thumb-down-2-fill',
        outlinedIcon: 'thumb-down-2-line',
        selectedVariant: IconVariants.DARK,
    },
];

export const formatDuration = ms => {
    if (!ms || ms < 0) return '0.0s';
    if (ms < 1000) return `${ms}ms`;
    const seconds = ms / 1000;
    if (seconds < 60) return `${seconds.toFixed(1)}s`;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds - minutes * 60;
    return `${minutes}m ${remainingSeconds.toFixed(0)}s`;
};
